/* import __COLOCATED_TEMPLATE__ from './base.hbs'; */
var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { CONSTANTS } from '@square/ember-multipass-components/components/ember-multipass-components/two-factor/enroll/auth-app';

/**
 * Input Props
 * @listTwoFactorResponse - https://prototype.sqprod.co/#/docs/squareup.multipass.external.ListTwoFactorResponse
 * @statusResponse - https://prototype.sqprod.co/#/docs/squareup.multipass.http.StatusResponse
 * @initTwoFactorEnrollModalOpen {boolean} - Begin with 2FA Enroll modal opened
 */
let TwoFactorMenuBaseComponent = (_dec = service('ember-multipass-flag'), _dec2 = service('ember-multipass-logging'), _dec3 = service('ember-multipassfe-client'), (_class = class TwoFactorMenuBaseComponent extends Component {
  get tPrefix() {
    return this.args.tPrefix || '';
  }
  get twoFactorHelpUrl() {
    return CONSTANTS.DEFAULT_TWO_FACTOR_HELP_URL;
  }
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "flags", _descriptor, this);
    _initializerDefineProperty(this, "logger", _descriptor2, this);
    _initializerDefineProperty(this, "multipassfeClient", _descriptor3, this);
    _initializerDefineProperty(this, "intl", _descriptor4, this);
    _initializerDefineProperty(this, "marketToasts", _descriptor5, this);
    _initializerDefineProperty(this, "enrollModalOpen", _descriptor6, this);
    _initializerDefineProperty(this, "enrollSecureContactModalOpen", _descriptor7, this);
    _initializerDefineProperty(this, "manageModalOpen", _descriptor8, this);
    _initializerDefineProperty(this, "phoneNumber", _descriptor9, this);
    _initializerDefineProperty(this, "phoneNumberDisplay", _descriptor10, this);
    this.initialize();
  }
  async initialize() {
    try {
      // Cache passed in results for downstream components, else fetch current value
      await Promise.all([this.cacheListTwoFactorResponse(), this.cacheStatusResponse()]);
      this.checkInitializeEnrollModalOpen();
    } catch (e) {
      this.logger.error('Failed to cache two factor data', e);
    }
  }
  checkInitializeEnrollModalOpen() {
    if (this.args.initTwoFactorEnrollModalOpen) {
      this.handleEnrollModalOpen();
    }
  }
  async cacheListTwoFactorResponse() {
    if (this.args.listTwoFactorResponse !== undefined) {
      this.multipassfeClient.twoFactorDetails = this.args.listTwoFactorResponse.two_factor_details;
      this.multipassfeClient.canDisablePersonalRequirement = this.args.listTwoFactorResponse.can_disable_personal_requirement;
    } else {
      await this.multipassfeClient.listTwoFactor();
    }
  }
  async cacheStatusResponse() {
    if (this.args.statusResponse !== undefined) {
      this.multipassfeClient.twoFactorProvidedTimestamp = this.args.statusResponse.two_factor_provided_timestamp;
      this.multipassfeClient.requiresTwoFactor = this.args.statusResponse.requires_two_factor;
      this.multipassfeClient.canUseSms = this.args.statusResponse.can_use_sms;
      this.multipassfeClient.canUseVoice = this.args.statusResponse.can_use_voice;
      this.multipassfeClient.hasPassword = this.args.statusResponse.has_password;
    } else {
      await this.multipassfeClient.status();
    }
  }
  handleEnrollModalOpen() {
    if (this.multipassfeClient.hasPassword) {
      this.enrollModalOpen = true;
      return;
    }
    if (this.args.handleNoPasswordScenario) {
      this.args.handleNoPasswordScenario();
    } else {
      this.marketToasts.critical(this.intl.t(`${this.tPrefix}generic_errors.other.unknown`));
    }
  }
  handleEnrollModalClose({
    dualEnrollSecureContactPhone = false,
    phoneNumber = '',
    phoneNumberDisplay = ''
  }) {
    this.enrollModalOpen = false;
    if (dualEnrollSecureContactPhone) {
      this.phoneNumber = phoneNumber;
      this.phoneNumberDisplay = phoneNumberDisplay;
      this.enrollSecureContactModalOpen = true;
    }
  }
  handleEnrollSecureContactModalClose() {
    this.enrollSecureContactModalOpen = false;
  }
  handleManageModalOpen() {
    this.manageModalOpen = true;
  }
  handleManageModalClose() {
    this.manageModalOpen = false;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "flags", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "logger", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "multipassfeClient", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "marketToasts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "enrollModalOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "enrollSecureContactModalOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "manageModalOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "phoneNumber", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "phoneNumberDisplay", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "handleEnrollModalOpen", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleEnrollModalOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleEnrollModalClose", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleEnrollModalClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleEnrollSecureContactModalClose", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleEnrollSecureContactModalClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleManageModalOpen", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleManageModalOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleManageModalClose", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleManageModalClose"), _class.prototype)), _class));
export { TwoFactorMenuBaseComponent as default };